export default __webpack_public_path__ + "static/media/logo.507c906d.svg";